import { createSelector } from 'reselect'

import { selectSelfServiceConfig } from './selectSelfServiceConfig'

export const selectIsUserVendor = createSelector([selectSelfServiceConfig], (selfServiceConfig) =>
  selfServiceConfig.get('is_vendor')
)
